export const REACT_FLOW_CLASSES = {
  ROOT: 'react-flow',
  CANVAS: 'react-flow__canvas',
  NODE: 'react-flow__node',
  VIEWPORT: 'react-flow__viewport',
  EDGE_LABEL: 'react-flow__edgelabel-renderer',
  PANE: 'react-flow__pane',
  EDGE: 'react-flow__edge',
} as const;

/** The keys that remove the selected nodes and edges. */
export const REACT_FLOW_DELETE_KEYS = ['Backspace', 'Delete'];

// These are semi magic values, some are pulled from the DOM
// others are hardcoded into the source code of react-flow
// Change them if they no longer work!
export const REACT_FLOW_ZINDEX = {
  NODE_BELOW_OVERLAY: -1,
  DEFAULT_NODE: 0,
  NODE_ABOVE_OVERLAY: 1,
  HELPER_LINES_CANVAS: 10,
  DRAGGING_NODE: 1000,
  EDGE_LABEL_RENDERER: 1001,
};

// ---------------------------------------------------------------------------
// Section Label Layout – Shared Spacing Constants
// ---------------------------------------------------------------------------
// These define vertical spacing rules used by FlowChart diagrams that leverage
// section-label nodes (e.g. Entity Diagram, Estate Waterfall).

/** Gap between a section label and the tallest child node within its section */
export const SECTION_LABEL_NODE_PADDING = 50;

/** Additional offset to position a label above its section content (top padding) */
export const SECTION_LABEL_TOP_PADDING = 28;

/** Gap between the bottom of one section's content and the next section's label */
export const INTER_SECTION_NODE_PADDING =
  SECTION_LABEL_NODE_PADDING + SECTION_LABEL_TOP_PADDING;
